<template>
  <div id="wenchangjin">
    <NavBar />

    <div id="hero" class="hero overlay subpage-hero">
      <div class="hero-content">
        <div class="hero-text">
          <h1>文昌金</h1>
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link to="/">首页</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link to="/products">产品</router-link>
            </li>
            <li class="breadcrumb-item active">文昌金</li>
          </ol>
        </div>
        <!-- /.hero-text -->
      </div>
      <!-- /.hero-content -->
    </div>
    <!-- /.hero -->

    <main id="main" class="site-main">
      <section class="site-section subpage-site-section section-project">
        <div class="container">
          <div class="row">
            <div class="col-md-12 mb-4">
              <div class="project-img">
                <img
                  :src="require('@/assets/img/products/wen-chang-jin.jpg')"
                  class="img-res mx-auto"
                  alt=""
                />
              </div>
              <!-- /.project-img -->
            </div>
            <aside class="col-md-12">
              <div class="project-info text-justify">
                <h5>『文昌金』</h5>

                <p class="project-description">
                  <span><b>焚化文昌金5大利益</b></span>
                </p>

                <p class="project-description">
                  焚化文昌金，保佑信众、读书学子，增进智慧，学业进步、考运顺利、功成名就。
                </p>

                <p class="project-description">
                  夫俗子如欲求得功名俸禄，祈求文昌帝君，赐福金榜题名，升官晋爵，心神安定，智慧增长，不迷惑，不忧惧，不恐慌，就要焚化文昌金给以自己镇定与信心之总和，为胜利的目标，勇往直前。
                </p>

                <p class="project-description">
                  文昌智慧显亿万千种之神异，飞鸾开化救劫，功存乎儒道释教，功德难量，神威莫测，九天辅开化主宰，司录职贡举真君，谈经演教消劫行化
                  种善果于诗书之圃，培桂根于阴之田，自雷杼炳灵于风山，至如意储祥于，正人心，必本于笃亲之孝，寿国脉，必先于致主之忠。文昌金阙上相，检校太师溷元内辅，三清上宰大都督府，管天地水三界狱事，判桂禄嗣籍上仙，编修飞仙列籍，掌溷元造化册。文昌渡人主宰，掌五湖四海河源，注禄定籍治事显道，扶善济苦消灾行化，育嗣天下聪明日益，开愚性以聪明，启迷心以颖悟，广布孝友文章之化，襄赞功名禄秩之权，文武科场闱内，判金榜于天宫，衡玉籍于桂香宝殿，五行秉德匡扶文运。焚化文昌金，保佑信众、读书学子，增进智慧，学业进步、考运顺利、功成名就。
                </p>

                <p class="project-description">
                  1.有助于家人读书，考试，顺利求取功名之位置。
                </p>

                <p class="project-description">
                  2.有利于宅中人职务之升迁调补。
                </p>

                <p class="project-description">
                  3.有益于个人事业之发展，或公司业务之推展。
                </p>

                <p class="project-description">
                  4.焚化文昌金不必再去找宅文昌或是个人文昌位。
                </p>

                <p class="project-description">
                  5.焚化文昌金，也可以代替文昌笔。
                </p>

                <p class="project-description">
                  于流年焚化文昌金，可令学生学业进步，考试从心所愿，焚化文昌金除了对从事教育工作或者求学人士有帮助外，也对一些文职工作或在签定合约的时候起到正面的作用。
                </p>

                <p class="project-description">
                  追求学问是人生中最重要的课程之一，从牙牙学语开始，到进幼稚园、小学、中学、大学或研究院，都是在追求知识的满足，即使进人了社会之后，各种谋生的技能与做人处事的准则，也是由学习而得来的，因此，掌管学问之神的文昌帝君，是极为重要的守护神之一
                </p>

                <p class="project-description">
                  諸葛孔明有限公司根据中国道教正统的科仪，推出了「文昌金」供莘莘学子与上班族、参加考试的人，得以获得文昌帝君与魁星爷的庇佑。
                </p>

                <p class="project-description">
                  焚化文昌金时不必默捻咒语。只要在这咒文「一笔点开天下事、七星照尽古今书、助我元辰光彩、助我：（善男、信女：
                  （姓名）、科甲功名有準、吾奉文昌帝君、急急如律令0填上姓名即可。
                </p>
              </div>
              <!-- /.project-description -->
            </aside>
          </div>
        </div>
      </section>
      <!-- /.section-project -->

      <RelatedProduct productCode="wen-chang-jin" />
    </main>
    <!-- /#main -->

    <Footer />
  </div>
</template>

<script>
/* eslint-disable */
import NavBar from "../partials/NavBar.vue";
import Footer from "../partials/Footer.vue";
import RelatedProduct from "./RelatedProduct.vue";

export default {
  name: "WenChangJin",
  data() {
    return {};
  },
  components: {
    NavBar,
    Footer,
    RelatedProduct
  },
  created() {}
};
</script>



// WEBPACK FOOTER //
// src/components/products/WenChangJin.vue